import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { feesincreaselistService } from './viewpendingrequest.service';
import { global } from '../../shared/global';
import { FeesIncrease } from '../Models/feesincrease.model'

declare var $: any;
@Component({
  selector: 'app-viewpendingrequest',
  templateUrl: './viewpendingrequest.component.html',
  styleUrls: ['./viewpendingrequest.component.css']
})
export class ViewpendingrequestComponent implements OnInit {
  searchtext;
  isDesc: boolean;
  column: string;
  FeesIncreaseList: Array<any>;
  FeesIncreaseDetail: Array<any>;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  HashCode: any;
  data: FeesIncrease;
  dropDownData: any;
  schools: any;
  newTotalFeesAmount: any;
  totalFeesAmount: any;
  mediums: any;
  stds: any;
  years: any;
  courseyears: any;
  totalPages = 10;
  totalFeesReq: any;

  constructor(private service: feesincreaselistService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    // if (this.rout.snapshot.paramMap.has('ID')) {
    //   this.HashCode = this.rout.snapshot.paramMap.get('ID');
    //   if (this.HashCode.trim() == "") {
    //     this.router.navigate(['/registrationlist']);
    //     return;
    //   }
    // } else {
    //   this.router.navigate(['/registrationlist']);
    //   return;
    // }
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.getFeesIncreaseList(this.p);
});
    this.fillMedium();
    this.fillStd();
    this.fillAcademicYear();
    $("#searchtext").val("");
    this.getFeesIncreaseList(this.p);
    this.data = new FeesIncrease();
  }

  fillMedium() {
    const data = {
      //HashCode: localStorage.getItem("HashCode")
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.data.MediumID = 0;
      });
  }

  fillStd() {
    const data = {
      //HashCode: localStorage.getItem("HashCode")
    };
    this.service.fillStandard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.stds = this.dropDownData.dropdownlist;
        this.data.CourseID = 0;
        this.data.CourseYearID = 0;
      });
  }

  fillAcademicYear() {
    const data = {
    };
    this.service.fillAcademicYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.years = this.dropDownData.dropdownlist;
        this.years.splice(0, 1);
        this.years.reverse();
        this.data.AcademicYearID = this.years[0]["value"];
      });
  }

  fillCourseYear(id) {
    if (this.data.CourseID != undefined && this.data.CourseID > 0) {
      for (var i = 0; i < this.stds.length; i++) {
        if (this.stds[i]["value"] == this.data.CourseID) {
          this.courseyears = [];
          for (var j = 1; j <= this.stds[i]["noofyear"]; j++) {
            var yeartext = this.displayyear(j);
            this.courseyears[this.courseyears.length] = { "id": 1, "text": yeartext, "value": j }
          }
        }
      }
    }
    this.data.CourseYearID = id
  }

  displayyear(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }

  getFeesIncreaseList(page) {
    this.spinner.show();
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      yearID: +localStorage.getItem("yearID"),
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit,
      YearID : localStorage.getItem("YearID")
    };
    this.service.getFeesIncreaseList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.FeesIncreaseList = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          //this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.show();
          this.FeesIncreaseList = this.responseData.ViewAllFeesIncreaseList;
         // this.totalPages = this.responseData.totalPages;
          this.totalFeesReq = this.responseData.totalCount;
          this.spinner.hide();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  editRequest(hashcode) {
    this.spinner.show();
    const data = {
      HashCode: hashcode,
      YearID : localStorage.getItem("YearID")
    };
    this.service.fillFeesIncreaseDetail(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          //this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.data = this.responseData;
          this.fillCourseYear(this.responseData["CourseYearID"]);
          this.newTotalFeesAmount = this.data["TotalFeesAmount"];
          this.totalFeesAmount = this.data["TotalFeesAmountActual"];
          $('#detailModal').modal('show');
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  // fillDetails() {
  //   for (var i = 0; i < this.FeesIncreaseDetail.length; i++) {
  //     if (this.FeesIncreaseDetail[i]["IsApproved"] == 1) {
  //       $('#Accept' + i).prop("checked", true);
  //       $('#Accept' + i).prop("disabled", true);
  //       $('#Reject' + i).prop("disabled", true);
  //       $('#Remark' + i).prop("disabled", true);
  //     }
  //     if (this.FeesIncreaseDetail[i]["IsApproved"] == 2) {
  //       $('#Reject' + i).prop("checked", true);
  //       $('#Reject' + i).prop("disabled", true);
  //       $('#Accept' + i).prop("disabled", true);
  //       $('#Remark' + i).prop("disabled", true);
  //     }
  //     $('#Remark' + i).val(this.FeesIncreaseDetail[i]["Remark"]);
  //   }
  //   this.spinner.hide();
  // }

  Action(action) {
    if (action == 2 && $('#txtRemark').val().toString().trim() == "") {
      this.toastr.error("Enter remark. Remark is required while rejecting request")
      return;
    }
    this.spinner.show();
    const data = {
      action: action,
      hashCode: this.data.HashCode,
      adminRemark: $('#txtRemark').val()
    }
    this.service.updateFeesIncreaseDetail(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
         // this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.toastr.success(this.responseData.message);
          this.closeForm();

        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  calculateTotal() {
    this.newTotalFeesAmount = 0;
    for (var i = 0; i < this.data.feesIncreaseList.length; i++) {
      if ($("#newAmt" + i).val() == "")
        $("#newAmt" + i).val('0')
      this.newTotalFeesAmount += parseFloat($("#newAmt" + i).val());
    }
    this.newTotalFeesAmount = this.newTotalFeesAmount.toFixed(2);
  }

  onlyDouble(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.FeesIncreaseList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  setpage() {
    this.p = 1;
  }

  closeForm() {
    $('#detailModal').modal('hide');
    this.data.ID = 0;
    this.data.HashCode = null;
    this.data.MediumID = 0;
    this.data.CourseID = 0;
    this.data.CourseYearID = 0;
    this.data.AcademicYearID = parseInt(this.years[0]["value"]);
    this.data.feesIncreaseList = [];
    this.getFeesIncreaseList(1);
  }
}
